// This is dependant on
//		inovestor.ms.web
//		inovestor.ms.core

; (function (window, $, undefined) {

	var httpBuffer = new HttpBuffer();
	var isRefreshingTokens = false;

	function refreshTokensAndRetryAll(refreshTokenEndpoint, refreshToken) {
		var refreshTokensSuccessCallback = function (response) {
			if (response && response.accessToken && response.refreshToken) {
				// Get the current tokens (as to not overwrite the identity token) and persists the new ones.
				var currentTokens = inovestor.ms.web.tokenManager.getTokens();
				inovestor.ms.web.tokenManager.setTokens(response.accessToken, response.refreshToken, currentTokens.identityToken);

				// Retry all previously failed requests.
				httpBuffer.retryAll(response.accessToken);
			} else {
				inovestor.ms.web.tokenManager.setTokens(undefined, undefined, undefined);
				httpBuffer.rejectAll();
			}
		}
		var refreshTokensErrorCallback = function (response) {
			inovestor.ms.web.tokenManager.setTokens(undefined, undefined, undefined);
			httpBuffer.rejectAll();
		}

		// Call the refresh token endpoint to try and get some new tokens
		$.post(refreshTokenEndpoint, { refreshToken: refreshToken })
			.then(refreshTokensSuccessCallback, refreshTokensErrorCallback)
			.always(function () { isRefreshingTokens = false; });
	}

	function HttpBuffer() {
		// Holds all the requests, so they can be re-requested in future.
		var buffer = [];

		this.add = add;
		this.retryAll = retryAll;
		this.rejectAll = rejectAll;

		// Add the ajax request to the buffer.
		function add(request, originalResponse, deferred) {
			buffer.push({
			    request: request,
			    originalResponse: originalResponse,
				deferred: deferred
			});
		}

		// Retries all the buffered requests and clears the buffer.
		function retryAll(accessToken) {
			for (var i = 0; i < buffer.length; ++i) {
				var item = buffer[i];
				retryHttpRequest(item.request, item.deferred, accessToken);
			}
			buffer = [];
		}

		// Abandon or reject (if reason provided) all the buffered requests.
		function rejectAll() {
			for (var i = 0; i < buffer.length; ++i) {
				var item = buffer[i];
				item.deferred.reject(item.originalResponse);
			}

			buffer = [];
		}

		function retryHttpRequest(request, deferred, accessToken) {
			modifyAuthorizationHeader(request, accessToken);

			$.ajax(request)
				.done(function (data, status, request) {
				    deferred.resolve(data, status, request);
				})
				.fail(function (response) {
					deferred.reject(response);
				});
		}

		function modifyAuthorizationHeader(request, accessToken) {
			if (request.headers) {
				if (request.headers.authorization) {
					request.headers.authorization = "Bearer " + accessToken;
				} else if (request.headers.Authorization) {
					request.headers.Authorization = "Bearer " + accessToken;
				}
			}
		}
	};

	/*
		Global function to be used when calling an authenticated API.
	*/
	inovestor.ms.web.pluginHttpRequestInterceptor = function (url, options) {
		if (inovestor.ms.core.isNullOrUndefined(url))
			throw "url is null or undefined";

		if (inovestor.ms.core.isNullOrUndefined(options))
			throw "options is null or undefined";

		var tokens = inovestor.ms.web.tokenManager.getTokens();

		if (!inovestor.ms.core.isNullOrUndefined(tokens)) {
		    var refreshTokenEndpoint = inovestor.ms.web.config.refreshTokenEndpoint;

			// Add the Authorization header
			var headers = options.headers || {};
			headers.authorization = "Bearer " + tokens.accessToken;
			options.headers = headers;

			var deferred = $.Deferred();

			// Trigger the call.
			$.ajax(url, options)
				.done(function (data, status, request) {
					// Everything went well, just resolve the deferred.
				    deferred.resolve(data, status, request);
				})
				.fail(function (response) {
					if (response.status === 401 && !inovestor.ms.core.isNullOrUndefined(tokens.refreshToken) && tokens.refreshToken !== '') {
						// It's a 401 and we have a refresh token. Buffer the request, try and get a new token and retry all buffered requests.
					    httpBuffer.add(this, response, deferred);

						if (!isRefreshingTokens) {
							isRefreshingTokens = true;
							refreshTokensAndRetryAll(refreshTokenEndpoint, tokens.refreshToken);
						}
					} else {
						// Not a 401, simply reject the deferred.
						deferred.reject(response);
					}
				});

			return deferred.promise();
		} else {
			return $.ajax(url, options);
		}
	};

})(window, jQuery);